import React from 'react';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import MuiCheckbox from '@mui/material/Checkbox';
import clsx from 'clsx';
import isArray from 'lodash/isArray';
import {
  FieldComponentProps,
} from 'components/anvilFormFillable/fields/types';
import {
  getStableKey,
} from 'components/anvilFormFillable/utils';
import { isEmptyString } from 'utils/helper';

function getSelectedChildIds(formDynamicField: FieldComponentProps['value']): string[] {
  return !isArray(formDynamicField?.value)
    ? []
    : formDynamicField.value.filter((childId) => !isEmptyString(childId));
}

export default function CheckboxGroup({
  field,
  value,
  onChange,
  error = false,
}: FieldComponentProps) {
  const selectedChildIds = getSelectedChildIds(value);

  function handleToggle(childId: string) {
    const nextSelectedChildIds = selectedChildIds.includes(childId)
      ? selectedChildIds.filter((selectedChildId) => selectedChildId !== childId)
      : [...selectedChildIds, childId];

    onChange?.({ ...value, value: nextSelectedChildIds });
  }

  return (
    <div className="w-full overflow-hidden">
      <FormControl className="w-full">
        <FormGroup className="!flex-row flex-nowrap overflow-x-auto space-x-2 w-full">
          {field?.children?.map((child) => (
            <div key={getStableKey(child, field.id)} className="flex-shrink-0">
              <FormControlLabel
                className={clsx('w-full whitespace-nowrap', { '!text-red-500': error })}
                classes={{
                  label: clsx('text-sm', { '!text-red-500': error }),
                }}
                label={child?.name}
                control={(
                  <MuiCheckbox
                    checked={selectedChildIds.includes(child?.id ?? '')}
                    onChange={() => {
                      handleToggle(child?.id ?? '');
                    }}
                    className="w-max"
                    sx={{
                      '& .MuiSvgIcon-root': {
                        fontSize: 16,
                      },
                    }}
                  />
                )}
              />
            </div>
          ))}
        </FormGroup>
      </FormControl>
    </div>
  );
}
